// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"33d98e8e","787":"ecee31f8"}[chunkId] + ".chunk.js";
};